import { tns } from 'tiny-slider/dist/tiny-slider'

const carListSlider = (sliderContainers) => {

    let sliders = document.querySelectorAll('.car-slider')

    if (typeof sliderContainers !== 'undefined' && sliderContainers) {
        sliders = sliderContainers;
    }

    sliders.forEach((slider, index) => {
        if(!slider.classList.contains('tns-slider') && slider.querySelectorAll('.item').length) {
            tns(
                {
                    'container': slider,
                    'items': 1,
                    'autoplay': false,
                    'preventActionWhenRunning': true,
                    'mouseDrag': 'mouseDrag',
                    'slideBy': "page",
                    'navPosition': "bottom",
                    'lazyload': true,
                    prevButton: slider.parentNode.parentNode.querySelector('.arrow-left-car-slider'),
                    nextButton: slider.parentNode.parentNode.querySelector('.arrow-right-car-slider'),
                    useLocalStorage: false,
                });
        }
    })
}
export default carListSlider

